var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App-textfield mdl-textfield"},[_c('label',{staticClass:"mdl-textfield__label perm-label",attrs:{"for":"textfield"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"App-textfield__input",domProps:{"innerHTML":_vm._s(_vm.formatSemicolonLinebreak)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-454cacf7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mdlDisplayfield.vue
// module id = l8ff
// module chunks = 1